import React from 'react';
import { CHECKOUT_PICK_UP_PAYMENT } from '../../../../other/CheckoutConstants';
import { translate } from '../../../../../../Services/translation';
import CheckoutPaymentFormDetails from './components/CheckoutPaymentFormDetails/CheckoutPaymentFormDetails';
import CheckoutPaymentFormAssembly from './components/CheckoutPaymentFormAssembly';
import constants from '../../../../../../constants';
import { useCheckoutFormSubmit } from '../../../../other/useCheckoutFormSubmit';
import CheckoutError from '../../../../other/CheckoutError';

const CheckoutPaymentForm = ({ checkout }) => {
  const { payload, errors, isSubmitting } = checkout || {};
  const {
    authenticated,
    isBusinessCustomer,
    selectedPaymentMethod,
    loginUrl,
    checkoutMode,
  } = payload || {};

  const { validateAndSubmit } = useCheckoutFormSubmit();
  const handlePlaceOrder = () => validateAndSubmit(checkout);

  if (
    !(
      selectedPaymentMethod?.id === CHECKOUT_PICK_UP_PAYMENT ||
      isBusinessCustomer
    )
  ) {
    return null;
  }

  const showLoginButton =
    !authenticated &&
    (isBusinessCustomer ||
      checkoutMode === constants?.checkoutMode?.companyCustomers);

  return (
    <>
      <CheckoutPaymentFormAssembly checkout={checkout} />
      <CheckoutPaymentFormDetails checkout={checkout} />
      <CheckoutError
        errors={errors?.selectedResellerId}
        className="body-sm text-error mt-8"
      />
      {showLoginButton ? (
        <a className="button mt-8 block w-full" href={loginUrl}>
          {translate('checkout.login.to.placeorder')}
        </a>
      ) : (
        <button
          className="button relative mt-8 block w-full disabled:cursor-wait disabled:text-transparent"
          onClick={handlePlaceOrder}
          disabled={isSubmitting}
        >
          {translate('checkout.placeorder')}
          {isSubmitting && (
            <span className="-translate-1/2 icon animate-hourglass-flip pointer-events-none absolute left-1/2 top-1/2 text-white">
              hourglass
            </span>
          )}
        </button>
      )}
    </>
  );
};

export default CheckoutPaymentForm;
